import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer">
        <div className="links">
          <Link to="/privacy-policy" className="link">
            Privacy Policy
          </Link>
          <a
            href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula"
            className="link"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Use
          </a>
          <a href="mailto:talalzeini+coffeefocus@icloud.com" className="link">
            Contact
          </a>
        </div>

        <div className="signature">Developed and built by Talal El Zeini</div>
      </div>
    </div>
  );
};

export default Footer;
